import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {      
      light: {
        primary: '#2c6b87',
        // primary: '115740',
        secondary: '#9F2B00',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        navBarColor: '#1976D2',
      },
    },
  },
});





